<template>
<div>
<div class="content_card" >
<div class="grid">
<div class="col-12">
<div class="content_card_content">
<div class="grid">

<FileUpload   accept=".xlsx, .xls, .csv" @select="onFilesAdded"    v-model="files" :multiple="false" :showUploadButton="false" :showCancelButton="false" :chooseLabel="$store.state.languages.lang_phrases.dosya_secin" :fileLimit="1"   :maxFileSize="10000000" class="">
</FileUpload>

<h4 class="text-primary">{{counter}}</h4>


</div>
</div>
</div>
</div>
</div>
</div>
</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs';
import moment from "moment"
import BeyzayaOzelSection from "./BeyzayaOzelSection"
const columns_arr = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","AA","AB","AC","AD","AE","AF","AG","AH","AI"];
export default {

  name: 'AddAddresses',

  data () {
    return {
    	files:[],
    	worksheet:null,
    	workbook:null,
    	current_row:0,
    	current_column:2,
    	counter:0,
    }
  },
  mounted()
  {

  },
  methods:{
  	onFilesAdded(event)
    {
     setTimeout(()=>{
     	this.handleXml(event.files[0])  
     })         
    },
    handleXml(f)
    {
    	this.showMessage("success","","dosya alındı")
    	let reader = new FileReader()
    	reader.onload = (e)=>{
    		let data = new Uint8Array(e.target.result)
    		let workbook = XLSX.read(data, {type: 'array'});
    		let current_sheet = workbook.SheetNames[0]; 
    		this.worksheet = workbook.Sheets[current_sheet];
    		this.readBusinessLine()


    	}
    	reader.readAsArrayBuffer(f);

    },
    async readBusinessLine()
    {
    	
    	this.current_row += await 1;
			this.current_column = await 0
			let bus_obj =  await {};
			let latitude
			let longitude
			let suppcode
			let first = await this.getCurrentCellValue()
			if(first || first!=="")
			{
				this.current_column = await 1
				latitude =  await this.getCurrentCellValue()
				if(latitude || latitude!=="")
				{
					this.current_column = await 2
					longitude =  await this.getCurrentCellValue()
					this.current_column = await 3
					suppcode =  await this.getCurrentCellValue()
					let formdata = new FormData()
					formdata.append("suppliercode",suppcode)
					formdata.append("latitude",latitude)
					formdata.append("longitude",longitude)
					this.generalSubmission(formdata,"/add_suppliers_address",this.afterreadBusinessLine)
				}
				else
				{				
					this.readBusinessLine()
				}
			}
			else
			{				
				return false
			}
			

    },
    afterreadBusinessLine(response)
    {
    	this.showMessage("success","","afterreadBusinessLine")
    	this.counter ++
    	this.readBusinessLine()
    },
    getCurrentCellValue()
	{
		let current_cell_address = columns_arr[this.current_column]+this.current_row;				
		let current_cell = this.worksheet[current_cell_address];
		let current_cell_value = (current_cell ? current_cell.v : undefined);
		if(current_cell_value==undefined)
		{
			current_cell_value = ""
		}
		return current_cell_value;

	},
  }
}
</script>

<style lang="css" scoped>
</style>